import AbstractInstaller from "../../core/application/AbstractInstaller";
import WorkspaceScreenMediator from "./view/WorkspaceScreenMediator";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";

export default class WorkspaceInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        SkinKeyRegistry.WORKSPACE_SCREEN_SKIN = this._mapMediator(WorkspaceScreenMediator, lib.MainAssets.WorkspaceScreenSkin);
    }
}